import React from 'react'
import { Helmet } from 'react-helmet'

import '../css/Gallery.css'

import Abebe from '../assets/img/abebe.jpg'
import Addis from '../assets/img/addis.jpg'
import Belay from '../assets/img/belay.jpg'
import Berhe from '../assets/img/berhe.jpg'
import Etana from '../assets/img/tent.jpg'
import Fikre from '../assets/img/fikre.jpg'
import Rahel from '../assets/img/rahel.jpg'
import Worku from '../assets/img/worku.jpg'
import Yilma from '../assets/img/yilma.jpg'
import Melaku from '../assets/img/melaku.jpg'
import Selamu from '../assets/img/selamu.jpg'
import Tefera from '../assets/img/tefera.jpg'
import Teferi from '../assets/img/teferi.jpg'
import Zewdie from '../assets/img/zewdie.jpg'
import Bisewer from '../assets/img/bisewer.jpg'
import Sileshi from '../assets/img/sileshi.jpg'
import Solomon from '../assets/img/solomon.jpg'
import Tadesse from '../assets/img/tadesse.jpg'
import Zelalem from '../assets/img/zelalem.jpg'
import Tewodros from '../assets/img/tewodros.jpg'
import Yeshitla from '../assets/img/yeshitla.jpg'
import Yohannes from '../assets/img/yohannes.jpg'

export default function Gallery() {
  return (
    <div id="gallery">
      <Helmet>
        <title>Gallery - Enoho Fikir</title>
      </Helmet>

      <h1>Gallery</h1>

      <h2>Videos</h2>

      <div id="video-gallery">
        <iframe src="https://www.youtube.com/embed/1rLaMpyQubg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
        <iframe src="https://www.youtube.com/embed/3WQMj9hgLxs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
        <iframe src="https://www.youtube.com/embed/0IQk5v97vfY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
        <iframe src="https://www.youtube.com/embed/vHNCdLfuyC8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
        <iframe src="https://www.youtube.com/embed/28MwIMO-j7s" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
      </div>

      <h2>Images</h2>
      <div id="image-gallery">
        <img src={ Abebe } />
        <img src={ Addis } />
        <img src={ Belay } />
        <img src={ Berhe } />
        <img src={ Etana } />
        <img src={ Fikre } />
        <img src={ Rahel } />
        <img src={ Worku } />
        <img src={ Yilma } />
        <img src={ Melaku } />
        <img src={ Selamu } />
        <img src={ Tefera } />
        <img src={ Teferi } />
        <img src={ Zewdie } />
        <img src={ Bisewer } />
        <img src={ Sileshi } />
        <img src={ Solomon } />
        <img src={ Tadesse } />
        <img src={ Zelalem } />
        <img src={ Tewodros } />
        <img src={ Yeshitla } />
        <img src={ Yohannes } />
      </div>
    </div>
  )
}